import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl } from '../common/base-list.component';
import { ServiceLocatorService } from '../common/service/service-locator.service';

@Component({
  selector: 'app-app-user-list',
  templateUrl: './app-user-list.component.html',
  styleUrls: ['./app-user-list.component.css']
})
export class AppUserListComponent extends BaseListCtl {

  constructor(public locator: ServiceLocatorService, public route: ActivatedRoute) {
    super(locator.endpoints.APPUSER,locator,route);
  }

  populateForm(form, data) {
    form.id = data.id;
    form.name = data.name;
    form.login=data.login;
    form.date=data.date;
    form.mobileId=data.mobileId;
    form.password=data.password;
    
    console.log('----->',data);
  }


  parseDate(dateString: string): Date {
    if (dateString) {
        return new Date(dateString);
    }
    return null;
}
   
   
  

}
